import React, {Component} from 'react';
import {connect} from 'react-redux';
import parseCalJSON, { getISODate } from './parseCalJSON.js';
import CalendarDisplay from './CalendarRender/CalendarDisplay.jsx';
import EventsDisplay from './EventsListRender/EventsDisplay.jsx';
import './Calendar.css';

import {
  appendEvents,
  setCurrentDate,
  setEventDate,
  setEventList,
  setMonthShown,
  setParsedEventsAndDaysOfEvents,
} from './redux/actions';
import {correctDateFormat, pastAndFutureEventsArr, sameMonthStrings} from './calendarHelper.js';
import { addNewEvents } from './expandEvents.js';

class CalendarEventDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currEventList: {},
    }
    this.eventListScrollRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.monthShown !== undefined && this.props.monthShown.length > 0) {
      this.props.setMonthShown({
        month: this.props.monthShown.month,
        year: this.props.monthShown.year,
      });
    }
    let currDate = new Date();
    if (this.props.today) {
      const [year, month, day] = this.props.today.split('-').map(Number);
      currDate = new Date(year, month - 1, day);
    }
    currDate.setHours(23, 59, 59, 0);
    this.props.appendEvents(this.props.initialEvents, this.props.initialOccurrencesByEventId);
    this.props.setCurrentDate(currDate, this.props.pageable, this.props.calendarBaseUrl);
    this.props.setEventDate(this.props.today || getISODate(currDate));
  }

  componentDidUpdate(prevProps) {
    if (this.props.eventList !== null && prevProps.eventList !== this.props.eventList) {
      let parsedEvents = {};
      if (this.props.eventList.length !== 0) {
        const eventList = addNewEvents(this.props.eventList, this.props.scheduleTimezone);
        parsedEvents = parseCalJSON(eventList, this.props.scheduleTimezone);
      }
      this.props.setParsedEventsAndDaysOfEvents(parsedEvents);
      if (this.props.eventDate) {
        this.setState({
          currEventList: parsedEvents[this.props.eventDate],
        });
      }
    }
    if (this.props.eventDate && prevProps.eventDate !== this.props.eventDate) {
      if (this.props.parsedEventList) {
        this.setState({
          currEventList: this.props.parsedEventList[this.props.eventDate],
        });
      }
    }
    if (this.props.eventDate && prevProps.eventDate !== this.props.eventDate) {
      const el = this.eventListScrollRef.current;
      if (el) el.scrollTop = 0;
    }
  }

  render() {
    const [past, future] = pastAndFutureEventsArr(this.props.parsedEventList, this.props.eventDate);
    // Only the personal and team calendars carry the signed-in viewer's
    // shifts, and this pack also renders club, band and school calendars, so
    // the chip appears only when the list holds a shift.
    const hasVolunteer = (this.props.eventList || []).some(e => e.event_type === 'volunteer');
    return (
      <div className="container-fluid CalendarLayout">
        <div className="row CalenderContainer">
          <div className="col-12 col-md-7 u-noPaddingMobile Calendar-wrapper">
            <div className="Calendar">
              <CalendarDisplay today={this.props.today} />
            </div>
            <div className='d-flex justify-content-start align-items-center py-3 gap-3'>
              <div className='mx-2 d-flex align-items-center gap-1'>
                <div className="EventIndicator game"></div>
                <span className='EventIndicator-Text'>Game</span>
              </div>
              <div className='me-2 d-flex align-items-center gap-1 '>
                <div className="EventIndicator event"></div>
                <span className='EventIndicator-Text'>Event</span>
              </div>
              <div className='mx-2 d-flex align-items-center gap-1'>
                <div className="EventIndicator meeting"></div>
                <span className='EventIndicator-Text'>Meeting</span>
              </div>
              {
                (this.props.showPractices !== undefined ? this.props.showPractices : window.location.href.includes('all_events')) ? (
                  <div className='me-2 d-flex align-items-center gap-1'>
                    <div className="EventIndicator practice"></div>
                    <span className='EventIndicator-Text'>Practice</span>
                  </div>
                ) : null
              }
              {
                hasVolunteer ? (
                  <div className='me-2 d-flex align-items-center gap-1'>
                    <div className="EventIndicator volunteer"></div>
                    <span className='EventIndicator-Text'>Volunteer</span>
                  </div>
                ) : null
              }
            </div>
          </div>
          <div className="col-12 col-md-5 u-noPaddingMobile">
            <div className="bg-white overflow-scroll" ref={this.eventListScrollRef}>
              <EventsDisplay
                events={this.state.currEventList}
                eventDate={this.props.eventDate}
                lastEvent={past}
                futureEventsList={future}
                showFuture={true}
                singleTeamView={this.props.singleTeamView}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.calendarEvents.error,
  fetching: state.calendarEvents.fetching,
  monthShown: state.calendarEvents.monthShown,
  eventList: state.calendarEvents.eventList,
  eventDate: state.calendarEvents.eventDate,
  parsedEventList: state.calendarEvents.parsedEventList,
  // showFutureEvents: state.calendarEvents.showFutureEvents,
});

const mapDispatchToProps = {
  appendEvents,
  setCurrentDate,
  setEventDate,
  setEventList,
  setMonthShown,
  setParsedEventsAndDaysOfEvents,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarEventDisplay);
